import React from 'react';
import { fireGtagEvent, getEventLabel } from '../../helpers/gtag-helpers';

const CLICK_DELAY = 50;

const trackLink = ({name, index, label, category, nonInteraction, href}) => {
  return e => {
    // Unless the destination URL is opening in a new window, enforce a delay
    if (e.target.target !== '_blank') {
      e.preventDefault();
      setTimeout(() => document.location.href = href, CLICK_DELAY)
    }

    const eventLabel = getEventLabel(label, index);

    fireGtagEvent(name, eventLabel, category, nonInteraction);
  }
}

export default (eventProps) => {
  return (args) => {
    const {children, href} = args

    return (
        <a {...args} onClick={trackLink({...eventProps, href})}>{children}</a>
    )
  }
}
